import db from '@/components/firebaseInit'
import { serverTimestanp } from '@/components/firebaseInit'
import { getMoment } from "@/utils/datetime.js";

const moment = getMoment();

export default {
    namespaced: true,
    state: {
        owner: undefined,
        dates: undefined,
        monthId: undefined,
        count: undefined,
        takedPaidDaysOff: undefined,
        status: undefined,
        history: [],
        id: undefined,
        hasLoaded: false,
        paidDayOffItems: [],
        paidDayOffTimecards: [],
        paidDaysOffCount: 0,
        hourly_salary: 0
    },
    mutations: {
        setOwner(state, owner) {

            if (!owner.commuting_allowance) {
                owner.commuting_allowance = 0
            }
            if (!owner.predefined_time) {
                owner.predefined_time = 8 * 3600
            }
            if (!owner.base_salary) {
                owner.base_salary = 0
            }
            state.owner = owner
        },
        setCount(state, count) {

            state.count = count

        },
        setDates(state, dates) {
            state.dates = dates
        },
        setMonthId(state, monthId) {
            state.monthId = monthId
        },
        setHistory(state, history) {
            state.history = history ? history : []
        },
        setId(state, id) {
            state.id = id

        },
        addHistory(state, history) {

            if (history && Object.keys(history).length > 0) {
                state.history.push(history)
            }
        },
        setStatus(state, status) {
            state.status = status ? status : '入力中'

        },
        setPaidDayOffTimecards(state, tcs) {

            state.paidDayOffTimecards = tcs
        },
        changeStatus(state, status) {
            state.status = status
        },
        changeOwnerSetting(state, owner) {
            console.log("changeOwnerSetting", owner)
            state.owner = owner
        },
        changeLoadingStatus(state, loading) {

            state.hasLoaded = loading
        },
        clearCount(state) {
            state.count = {
                time: {
                    holidayWork: 0,
                    holidayLateNight: 0,
                    work: 0,
                    lateNight: 0,
                    overtime: 0,
                    paidDayOff: 0,
                    noPaidDayOff: 0,
                    monthly_predefined: 0,
                    diffrence_monthly_predefined_and_work: 0,
                    homeWork:0,
                },
                date: {
                    dates: 0,
                    paidDayOff: 0,
                    mDay: 0,
                    noPaidDayOff: 0,
                    absence: 0,
                    workingDay: 0,
                    holidayWorkingDay: 0,
                    dayOff: 0,
                    makeUpHoliday: 0,
                    predefinedHoliday: 0,
                    closedDay: 0,
                    homeWorkDay: 0,
                },
                money: {
                    sumTravelExpenses: 0,
                    sumOtherExpenses: 0,
                    daily_commuting_allowance: 0,
                    overtime: 0,
                    holiday: 0,
                    deficit: 0,
                    commuting_allowance: 0,
                    base_salary: 0,
                    late_night: 0,
                    roudou: 0,
                    kenko_insurance: 0,
                    kouseinenkin_insurance: 0,
                    subtotalInsurance: 0
                },
                cost: {}
            }
            state.takedPaidDaysOff = []
        },
        countTime(state, timecard) {
            const timeCount = state.count.time
            // const lateNightTime = 22 * 3600;
            const workTime = getWorktime(timecard)
            // const workLateNightTime = (timecard.end - lateNightTime <= 0 ? 0 : timecard.end - lateNightTime);
            const lateNightStartTime = 22 * 3600;
            const lateNightEndTime = 29 * 3600;
            
            let  lateNightTime = 0
            if(timecard.end > lateNightStartTime){
              if(timecard.end > lateNightEndTime){
                lateNightTime = lateNightEndTime - lateNightStartTime
              }else{
                lateNightTime = timecard.end - lateNightStartTime
              }
            }
            const workLateNightTime = ('break_late_night' in timecard) ? lateNightTime - timecard.break_late_night : lateNightTime
            
            if (isHoliday(timecard)) {
                timeCount.holidayWork += workTime
                timeCount.holidayLateNight += workLateNightTime
            } else {
                timeCount.work += workTime
                timeCount.lateNight += workLateNightTime
            }

            if (state.owner.work_type == "一般") {
                timecard.overtime = workTime - state.owner.predefined_time;
            } else {
                timecard.overtime = workTime > 3600 * 8 ? workTime - 3600 * 8 : 0
            }
            timeCount.overtime += timecard.overtime
            timeCount.homeWork += timecard.actual_home_working_hours ? timecard.actual_home_working_hours : 0

            if (state.owner.fixed_salary) {
                timeCount.overtime = 0
                timeCount.holidayLateNight = 0
                timeCount.lateNight = 0
                timeCount.holidayWork = 0
            }
        },
        countDate(state, timecard) {
            const dateCount = state.count.date
            switch (timecard.holidayType) {
                case "有休":
                    dateCount.paidDayOff++;
                    dateCount.workingDay += 1;
                    state.takedPaidDaysOff.push({ date_id: timecard.date_id, days: 1 });
                    break;
                case "特別有休（M休やV休）":
                case "M休":
                    dateCount.mDay++;
                    dateCount.workingDay += 1;
                    break;
                case "半休":
                    dateCount.paidDayOff = dateCount.paidDayOff + 0.5;
                    dateCount.workingDay += 1;
                    state.takedPaidDaysOff.push({ date_id: timecard.date_id, days: 0.5 });
                    break;
                case "無給":
                    dateCount.noPaidDayOff++;
                    break;
                case "欠勤":
                case "産前休":
                case "産後休":
                case "育児休":
                case "介護休":
                case "休職":
                case "その他休":
                    dateCount.absence++;
                    break;
                case "半欠勤":
                    dateCount.absence = dateCount.absence + 0.5;
                    dateCount.workingDay += 1;
                    break;
                case "振出":
                    dateCount.workingDay++;
                    dateCount.makeUpHoliday++;
                    break;
                case "振休":
                    dateCount.makeUpHoliday--;
                    break;
                case "所定休":
                case "振休(所定休)":
                    dateCount.predefinedHoliday++;
                    break;
                default:
                    if (getWorktime(timecard) > 0) dateCount.workingDay++;
                    break;

            }
            if (isHoliday(timecard) && getWorktime(timecard) > 0) {
                dateCount.holidayWorkingDay++;
            }
            if(timecard.working_hours.length > 0 && timecard.working_hours.every(hour => hour.type=='在宅') && !isHoliday(timecard)) dateCount.homeWorkDay++;

        },
        countCalendarDate(state, date) {
            const dateCount = state.count.date
            dateCount.dates++;
            if (date.is_holiday || date.day_number == 0 || date.day_number == 6) {
                dateCount.dayOff++;
            }
        },
        countMoney(state, timecard) {
            const moneyCount = state.count.money
            timecard.expenses.forEach(tc => {
                (tc.type == "営業交通費" || tc.type == "その他交通費" )
                    ? (moneyCount.sumTravelExpenses += Number(tc.price))
                    : (moneyCount.sumOtherExpenses += Number(tc.price));
            });

        const isNumber = function(value) {
            return ((typeof value === 'number') && (isFinite(value)));
        };
            if (isNumber(timecard.daily_commuting_allowance)) {
                moneyCount.daily_commuting_allowance += timecard.daily_commuting_allowance
            }
        },
        countCost(state, timecard) {
            const costCount = state.count.cost
            let totalCost = 0
            Object.keys(timecard.costs).forEach(key => {
                const cost = timecard.costs[key];

                if (cost.client_id in costCount) {
                    costCount[cost.client_id].time += cost.time;
                } else {
                    costCount[cost.client_id] = JSON.parse(JSON.stringify(cost));                 
                }

                if (cost.time > 0) totalCost += cost.time
            });
            if (costCount.total) {
                costCount.total += totalCost
            } else {
                costCount.total = totalCost
            }
        },
        countDateOfMonth(state) {
            const dates = state.count.date

            dates.closedDay = dates.dayOff + dates.predefinedHoliday
            dates.regularWorkDay = dates.dates - dates.closedDay
            dates.calendarWorkDay = dates.dates - dates.dayOff

        },
        countTimeOfMonth(state) {
            const dates = state.count.date
            const times = state.count.time;

            times.paidDayOff =
                (dates.paidDayOff + dates.mDay) * state.owner.predefined_time;
            times.noPaidDayOff = dates.noPaidDayOff * state.owner.predefined_time;
            times.monthly_predefined =
                dates.regularWorkDay *
                state.owner.predefined_time;
            times.diffrence_monthly_predefined_and_work =
                times.monthly_predefined - (times.work + times.paidDayOff);
            if (state.owner.few_work_days) {
                times.monthly_worktime_by_law = dates.calendarWorkDay * 8 * 3600
                times.overtime_by_law = (times.work + times.paidDayOff) - times.monthly_worktime_by_law;
                if (times.overtime_by_law < 0) times.overtime_by_law = 0;
            }
            if (state.owner.fixed_salary) {
                times.diffrence_monthly_predefined_and_work = 0
            }


        },
        countMoneyOfMonth(state) {

            const times = state.count.time;
            const moneies = state.count.money;
            let hourly_salary = 0;
            let base_salary = 0;
            if (state.owner.work_type == "一般") {
                if(state.owner.is_joining_in_the_middle && state.owner.monthly_base_salary > 0){
                    base_salary = state.owner.monthly_base_salary 
                }else{
                    base_salary = state.owner.base_salary
                }
                if (state.owner.few_work_days) {
                    const work_days_per_week = state.owner.work_days_per_week || 5
                    hourly_salary = base_salary / ((state.owner.predefined_time / 3600) * work_days_per_week * 4)
                } else {
                    hourly_salary = base_salary / ((state.owner.predefined_time / 3600) * 20)
                }

            } else {
                hourly_salary = state.owner.hourly_base_salary;
            }
            state.hourly_salary = hourly_salary
            const hourly_overtime = Math.ceil(hourly_salary * 1.25);
            const hourly_holiday = Math.ceil(hourly_salary * 1.35);
            const hourly_late_night = Math.ceil(hourly_salary * 0.25);
            const hourly_under_time = Math.floor(hourly_salary);
            hourly_salary = Math.ceil(hourly_salary)

            if (state.owner.commuting_allowance_type == "日額") {
                moneies.commuting_allowance = moneies.daily_commuting_allowance
            } else {
                moneies.commuting_allowance = state.owner.commuting_allowance;
            }

            if (state.owner.work_type == "一般") {
                moneies.overtime =
                    times.diffrence_monthly_predefined_and_work < 0
                        ? Math.ceil(
                            ((-1 * times.diffrence_monthly_predefined_and_work) / 3600) *
                            hourly_overtime
                        )
                        : 0;
                moneies.holiday = Math.ceil(
                    (times.holidayWork / 3600) * hourly_holiday
                );
                moneies.deficit =
                    times.diffrence_monthly_predefined_and_work > 0
                        ? Math.ceil(
                            (times.diffrence_monthly_predefined_and_work / 3600) *
                            hourly_under_time
                        )
                        : 0;
                moneies.base_salary = Number(state.owner.base_salary)
                if (state.owner.few_work_days) {
                    const overtime =
                        times.diffrence_monthly_predefined_and_work < 0
                            ? Math.ceil(
                                (((-1 * times.diffrence_monthly_predefined_and_work) - times.overtime_by_law) / 3600) *
                                hourly_salary
                            )
                            : 0;
                    moneies.overtime = overtime + Math.ceil((times.overtime_by_law / 3600) * hourly_overtime)
                }
                if (state.owner.fixed_salary) {
                    moneies.overtime = 0
                    moneies.deficit = 0
                }

            }
            else {
                moneies.overtime = Math.ceil(
                    (hourly_overtime * times.overtime) / 3600
                );
                moneies.base_salary = Math.ceil(
                    (hourly_salary *
                        (times.work + times.holidayWork + times.paidDayOff - times.overtime)) /
                    3600
                );
                moneies.holiday = 0
                moneies.deficit = 0

            }
            moneies.late_night = Math.ceil(((times.lateNight) / 3600) * hourly_late_night)
                + Math.ceil(((times.holidayLateNight) / 3600) * hourly_late_night);
            moneies.late_night_on_holiday = Math.ceil(((times.holidayLateNight) / 3600) * hourly_late_night);
            moneies.late_night_on_workday = Math.ceil(((times.lateNight) / 3600) * hourly_late_night);

            moneies.subtotalSalary =
                moneies.base_salary +
                moneies.overtime +
                moneies.holiday +
                moneies.late_night -
                moneies.deficit
            moneies.totalExpences = + moneies.commuting_allowance + moneies.sumTravelExpenses + moneies.sumOtherExpenses
            moneies.totalSalary = moneies.subtotalSalary + moneies.totalExpences

            const monthId = state.monthId
            
            const targetDate = moment('2024-03-01')
            const isAfterTarget = moment(monthId).isSameOrAfter(targetDate)
            const roudou_permillage = isAfterTarget ? 9.5 : 9.0

            moneies.roudou = Math.round((moneies.subtotalSalary + moneies.commuting_allowance) * roudou_permillage / 1000);

            moneies.kenko_insurance = NumberOrZero(state.owner.kenko_insurance)
            moneies.kouseinenkin_insurance = NumberOrZero(state.owner.kouseinenkin_insurance)
            moneies.subtotalInsurance = moneies.roudou + moneies.kenko_insurance + moneies.kouseinenkin_insurance


        },
        setPaidDayOffItems(state, items) {

            state.paidDaysOffCount = 0

            if (items.length == 0) {
                state.paidDaysOffCount = 0;
            } else {
                items.forEach(i => {
                    if (i.isDisplayed) state.paidDaysOffCount += i.days_left;
                })
            }
            state.paidDayOffItems = items
        }
    },
    getters: {
        owner(state) {
            return state.owner
        },
        hourlySalary(state) {
            return state.hourly_salary
        },
        id(state) {
            return getTimesheetId(state.owner.id, state.monthId)
        },
        timesheetItems(state) {
            return state.dates
        },
        monthId(state) {
            return state.monthId
        },
        dateCounts(state) {
            return state.count.date
        },
        timeCounts(state) {
            return state.count.time
        },
        moneyCounts(state) {
            return state.count.money
        },
        costCounts(state) {
            return state.count.cost
        },
        timesheetStatus(state) {
            return state.status
        },
        timesheetHistory(state) {
            return state.history
        },
        timesheet(state) {
            return {
                user_id: state.owner.id,
                month_id: state.monthId,
                staff_id: state.owner.staff_id,
                user_name: state.owner.name,
                team_name: state.owner.team_name,
                work_type: state.owner.work_type,
                owner: state.owner,
                counts: state.count,
                status: state.status,
                paid_days_off_count: state.paidDaysOffCount,
                history: state.history,
                version: 2
            };

        },
        hasLoaded(state) {

            return state.hasLoaded
        },
        paidDayOffTimecards(state) {
            return state.paidDayOffTimecards
        },
        paidDayOffItems(state) {
            return state.paidDayOffItems
        },
        paidDaysOffCount(state) {
            return state.paidDaysOffCount
        }
    },
    actions: {
        async getTimesheet({ commit, dispatch }, { monthId, ownerId }) {
            commit('changeLoadingStatus', false)
            commit('setStatus', "読み込み中")
            commit('setMonthId', monthId)
            commit('clearCount')

            const timesheetDocs = await db.collection("timesheets")
                .where("user_id", "==", ownerId)
                .where("month_id", "==", monthId)
                .orderBy('updatedAt', 'desc')
                .get();

            const timesheetId = getTimesheetId(ownerId, monthId)
            const timesheetDoc = await db.collection("timesheets").doc(timesheetId).get();
            const promises = []

            let sheet = null

            // 常にusersコレクションから最新のownerデータを取得
            let latestOwner = null
            try {
                const ownerDoc = await db
                    .collection("users")
                    .doc(ownerId)
                    .get();
                
                if (ownerDoc.exists) {
                    latestOwner = { ...ownerDoc.data(), id: ownerId };
                }
            } catch (e) {
                console.error(e);
            }

            if (timesheetDoc.exists) {
                sheet = timesheetDoc.data()
                commit('setHistory', sheet.history)
                // timesheetのownerを優先（存在する場合）
                const ownerToUse = sheet.owner || latestOwner
                commit('setOwner', ownerToUse)

                commit('setStatus', sheet.status == "読み込み中" ? "入力中" : sheet.status)

                if (sheet.status != "入力中"){

                    commit('setCount', sheet.counts)
                }
            }
            else {
                //copy to timesheet from old timesheet

                if (!timesheetDocs.empty) {

                    if (timesheetDocs.size == 1) {
                        sheet = timesheetDocs.docs[0].data()

                    } else {

                        const sheets = []
                        timesheetDocs.forEach(doc => {
                            sheets.push(doc.data())
                        })
                        const sh = sheets.find(sh => sh.status != "読み込み中" && sh.status != "入力中")
                        if (sh) {
                            sheet = sh
                        } else {
                            sheet = sheets[0]
                        }
                    }

                    commit('setHistory', sheet.history)
                    // timesheetのownerを優先（存在する場合）
                    const ownerToUse = sheet.owner || latestOwner
                    commit('setOwner', ownerToUse)
                    commit('setStatus', sheet.status == "読み込み中" ? "入力中" : sheet.status)

                } else {
                    commit('setStatus', "入力中")
                    if (latestOwner) {
                        commit('setOwner', latestOwner);
                    }

                }

            }


            const dates = [];
            try {
                const dateCollection = await db.collection("calendar")
                    .doc(monthId)
                    .collection("dates")
                    .get();
                dateCollection.forEach(doc => {
                    const item = doc.data();
                    dates.push({ ...item, id: doc.id });
                });
            } catch (e) {
                console.error(e)
            }
            const timecards = {};
            try {
                const timecardDocs = await db.collection("timecards")
                    .where("owner_id", "==", ownerId)
                    .where("month_id", "==", monthId)
                    .get();
                timecardDocs.forEach(doc => {
                    const item = doc.data();
                    timecards[item.date_id] = { ...item, id: doc.id, };
                });
            } catch (e) {
                console.error(e)
            }
            dates.forEach(d => {
                if (d.id in timecards) {
                    d.timecard = timecards[d.id]
                } else {
                    d.timecard = null
                }
                if (sheet == null || sheet.status == '入力中') {
                    commit('countCalendarDate', d)
                    if (d.timecard && d.timecard.is_completed) {

                        commit('countTime', d.timecard)
                        commit('countDate', d.timecard)
                        commit('countMoney', d.timecard)
                        commit('countCost', d.timecard)
                    }
                } else {
                    //一般以外はデイリーの超過時間をタイムシートに表示しているが、デイリーの超過時間は集計時に保存してる
                    //入力中以外は集計をしないため、超過時間がタイムシートでみれなくなった
                    //そのための対応
                    if (sheet.owner.work_type != "一般" && d.timecard && d.timecard.is_completed) {
                        const workTime = getWorktime(d.timecard)
                        d.timecard.overtime = workTime > 3600 * 8 ? workTime - 3600 * 8 : 0
                    }
                }
            })
            if (sheet == null || sheet.status == '入力中') {

                commit('countDateOfMonth')
                commit('countTimeOfMonth')
                commit('countMoneyOfMonth')

            }
            commit('setDates', dates)
            await dispatch("getPaidDayOffItems", { ownerId: ownerId, monthId: monthId })

            commit('changeLoadingStatus', true)
            await dispatch("saveTimesheet")

            // if (!timesheetDocs.empty) {
            //     timesheetDocs.forEach(doc => {
            //         const timesheet = doc.data()                 
            //         if (!(timesheet.version && timesheet.version >= 2)) {
            //             const p = deleteTimesheet(doc.id)
            //             promises.push(p)
            //         }
            //     });
            // }
            await Promise.all(promises)
        },
        async saveTimesheet({ getters }) {

            const timesheet = getters.timesheet

            timesheet.updatedAt = serverTimestanp()
            try {
                await db.collection("timesheets").doc(getters.id).set(timesheet, { merge: true });


            } catch (e) {
                console.error(e);
            }

        },
        async changeTimesheetStaus({ commit, getters }, { status, history }) {
            commit('addHistory', history)
            commit('changeStatus', status)
            
            const timesheet = getters.timesheet
            
            timesheet.updatedAt = serverTimestanp()

            try {

                await db.collection("timesheets").doc(getters.id).update(timesheet);

            } catch (e) {
                console.error(e);
            }

        },
        async updateTimesheetSetting({ commit, getters }, owner) {
            commit('changeOwnerSetting', owner)
            
            // 再計算
            commit('clearCount')
            const dates = getters.timesheetItems
            
            if (dates && dates.length > 0) {
                dates.forEach(d => {
                    commit('countCalendarDate', d)
                    if (d.timecard && d.timecard.is_completed) {
                        commit('countTime', d.timecard)
                        commit('countDate', d.timecard)
                        commit('countMoney', d.timecard)
                        commit('countCost', d.timecard)
                    }
                })
                commit('countDateOfMonth')
                commit('countTimeOfMonth')
                commit('countMoneyOfMonth')
            }
            
            // Firestoreに保存
            const timesheet = getters.timesheet
            const docId = getters.id
            
            if (!docId) {
                console.error("Document ID is undefined!")
                return
            }
            
            timesheet.updatedAt = serverTimestanp()
            
            try {
                await db.collection("timesheets").doc(docId).set(timesheet, { merge: true });
            } catch (e) {
                console.error("Failed to update timesheet:", e)
                throw e
            }
        },
        async getPaidDayOffItems({ commit, dispatch, getters }, { ownerId, monthId }) {
            const endOfThisMonth = moment(monthId).endOf("month").unix()
            const startOfThisMonth = moment(monthId).startOf("month").unix()

            try {
                const querySnapshot = await db.collection("paid_days_off")
                    .where("owner_id", "==", ownerId)
                    .get();
                const items = [];
                querySnapshot.forEach(doc => {
                    const item = { ...doc.data(), id: doc.id, isUsed: false };
                    item.days_left = item.add_days;
                    item.historys = [];
                    item.giveDate = item.give_date || moment.unix(item.deadline).subtract(2,'year').add(1,'day').unix()
                    item.isDisplayed = (item.deadline >= startOfThisMonth)&& (item.giveDate < endOfThisMonth)

                    items.push(item);
                });

                const sortedItems = items.sort((a, b) => {
                    return a.deadline - b.deadline;
                });
                await dispatch("getDayOffTimecards", { ownerId: ownerId, endOfThisMonth: endOfThisMonth });
                const timecards = getters.paidDayOffTimecards

                timecards.forEach(tc => {
                    for (let i = 0; i < sortedItems.length; i++) {
                        if (
                            sortedItems[i].deadline >= tc.unixtime &&
                            !sortedItems[i].isUsed
                        ) {
                            const daysLeft = sortedItems[i].days_left - tc.numberOfDays;
                            if (daysLeft > 0) {
                                sortedItems[i].days_left = daysLeft;
                                sortedItems[i].historys.push(tc);
                                break;
                            } else if (daysLeft == 0) {
                                sortedItems[i].days_left = daysLeft;
                                sortedItems[i].historys.push(tc);
                                sortedItems[i].isUsed = true;
                                break;
                            } else if (daysLeft == -0.5) {
                                sortedItems[i].days_left = 0;
                                sortedItems[i + 1].days_left = sortedItems[i + 1].days_left - 0.5;
                                sortedItems[i].historys.push(tc);
                                sortedItems[i + 1].historys.push(tc);
                                sortedItems[i].isUsed = true;
                                break;
                            }
                        }
                    }
                });
                commit("setPaidDayOffItems", sortedItems)
            } catch (e) {
                console.error(e);
            }
        },
        async getDayOffTimecards({ commit }, { ownerId, endOfThisMonth }) {
            const timecards = [];
            try {
                const dayOffDocs = await db.collection("timecards")
                    .where("owner_id", "==", ownerId)
                    .where("holidayType", "==", "有休")
                    .where("unixtime", ">=", moment("2020-05-01").unix())
                    .where("unixtime", "<=", endOfThisMonth)
                    .get();
                const halfDayOffDocs = await db.collection("timecards")
                    .where("owner_id", "==", ownerId)
                    .where("holidayType", "==", "半休")
                    .where("unixtime", ">=", moment("2020-05-01").unix())
                    .where("unixtime", "<=", endOfThisMonth)
                    .get();

                dayOffDocs.forEach(doc => {
                    timecards.push({ ...doc.data(), numberOfDays: 1 });
                });
                halfDayOffDocs.forEach(doc => {
                    timecards.push({ ...doc.data(), numberOfDays: 0.5 });
                });

                commit("setPaidDayOffTimecards", timecards.sort((a, b) => {
                    return a.unixtime - b.unixtime;
                })
                )


            } catch (e) {
                console.error(e);
                throw (e)
            }
        },

    }
}



function isHoliday(timecard) {
    return (timecard.day_number == 0 || timecard.is_holiday || timecard.day_number == 6 || timecard.holidayType == "振休")
        && timecard.holidayType != "振出"

}
function getWorktime(timecard) {
    return timecard.end - timecard.start - timecard.lunch - timecard.break - (timecard.total_nonworking_hours ? timecard.total_nonworking_hours : 0)
}

// function deleteTimesheet(id) {
//     return db.collection("timesheets").doc(id).delete().then(() => {
//     }).catch(function (error) {
//         console.error("Error removing document" + id + ": ", error);
//     });
// }
function NumberOrZero(num) {
    return Number(num) ? Number(num) : 0
}
function getTimesheetId(ownerId, monthId) {
    return ownerId + "-" + monthId
}